module.exports = __webpack_public_path__ + "img/Sydney.c29b49e5.jpg";